import Vue from 'vue';
import GlobalMixin from './mixins/global';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { route } from 'ziggy-js';
import VueTailwind from 'vue-tailwind';
import { bootVueApps } from './utils/loader';
Vue.component('v-select', vSelect);
require('../global/axios');
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
window.Vapor = require('laravel-vapor');
Date.now = () => new Date().getTime();
Vue.use(VueTailwind);
Vue.mixin(GlobalMixin);
Vue.mixin({
    methods: {
        route: (name, params, absolute, config) => route(name, params, absolute, config),
    },
});
bootVueApps();
